import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios'; // Import axios for making HTTP requests 
import { Button, Snackbar} from '@mui/material';
import { jwtDecode } from 'jwt-decode';
const WhyusForm = () => {
  const token = sessionStorage.getItem('authToken');
  const currentTime = Date.now() / 1000; // Current time in seconds
  const [isTokenValid, setIsTokenValid] = useState(true); // Token validity state
    const { register, handleSubmit, trigger, formState: { errors } } = useForm(); // Use trigger for manual validation
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
      });
      const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
      };
      
    const [formData,setFormData] =useState({
        title: '',
        description: '',
        })

        
          const onSubmit = async (data) => {
            try {
                      if (token) {
                                      try {
                                          const decodedToken = jwtDecode(token);
                      
                                          const expiryTime = decodedToken.exp; // Token expiration time from the JWT
                      
                                          // Check if the token is expired
                                          if (expiryTime < currentTime) {
                                              setIsTokenValid(false);
                                              
                                          } else {
                                              setIsTokenValid(true);
                                              // Token is still valid, continue with your logic
                                          }
                                      } catch (error) {
                                          console.error("Error decoding the token", error);
                                          setIsTokenValid(false);
                                      
                                      }
                                  } else {
                                      setIsTokenValid(false);
                                      
                                  }
                // Now, submit the form data along with the image URLs in the `imagess` field
                const response = await axios.post(
                  'https://zoomautos.co.uk/api/Features',
                  {
                      formType: 'WhyUSForm',
                      ...data, // Spread the rest of the form data
                  },
                  {
                      headers: {
                          Authorization: `Bearer ${token}`,
                      },
                  }
              );
              
        
                console.log("Why Us feature submitted successfully:", response.data); // Log success response
        
                // Show success snackbar
                setSnackbar({ open: true, message: 'Form submitted and PDF sent via email!', severity: 'success' });
        
                // Reset the form after submission
                setFormData({
                    title: '',
                    description: '',
                    })
                // Delay reload by 3 seconds
                setTimeout(() => {
                    window.location.reload();
                }, 3000); // 3 seconds delay for page reload
        
            } catch (error) {
                console.error('Error submitting form:', error); // Log error details
                // Handle errors with proper error feedback (Snackbar or alert)
                const errorMessage = error.response ? error.response.data.message || error.message : error.message;
                setSnackbar({ open: true, message: errorMessage, severity: 'error' });
            }
        };
    return(
<>
<h1 style={{marginTop:'100px'}}>Add Features for Car Sale Website Home Page</h1>
<div className="adminaddform-container" style={{ marginBottom: '200px'}}>
        <form onSubmit={handleSubmit(onSubmit)}>
      
<div className="form-row">
                  <div className="form-group">
                    <h3>Feature Title</h3>
                    <input type="text" {...register('title', { required: 'title is required' })} placeholder="Title" style={{width:'100%'}} />
                    {errors.title && <p className="error-message">{errors.title.message}</p>}
                  
                    <h3>Feature Description</h3>
                    <textarea type="text" {...register('description', { required: 'description is required' })} placeholder="Description" style={{width:'100%'}} rows={8}  // Adjust the number of rows for the textarea
           />
                    {errors.title && <p className="error-message">{errors.title.message}</p>}
                  
              </div>
              </div>
              <div className='form-row' style={{alignContent:'center',

justifyContent: 'center', 
alignItems: 'center', 
              }}>
              <button type="submit" className='contact-button' style={{width:'50%'}} onClick={handleSubmit(onSubmit)}>
                  Submit
                </button>
                </div>
              
              </form>
              </div>


<Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbar.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          className="MuiSnackbar-root"
          action={
            <Button color="inherit" className="MuiButton-text" onClick={handleCloseSnackbar}>
              Close
            </Button>
            
          }
        />
</>
    )
}
export default WhyusForm;